// src/pages/SODashboard.js
import React, { useState, useEffect } from "react";
import { signOut } from "firebase/auth";
import { auth, db } from "../../firebase";
import { useNavigate } from "react-router-dom";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  serverTimestamp,
  doc,
  getDoc,
} from "firebase/firestore";
import styles from "../../styles/Dashboard/GMDashboard.module.css";
import { FiMenu } from "react-icons/fi";
import logo from "../../assets/logo.jpg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const DealerDashboard = () => {
  const [activeTab, setActiveTab] = useState("placeOrder");
  const [partyMobile, setPartyMobile] = useState("");
  const [pod, setPod] = useState([]);
  const [products, setProducts] = useState([]);
  const [partyCode, setPartyCode] = useState("");
  // const [partyName, setPartyName] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [soName, setSoName] = useState("");
  const [contactInfo, setContactInfo] = useState("");
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [filterProduct, setFilterProduct] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [rejectionMessage, setRejectionMessage] = useState("");




  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const navigate = useNavigate();

  const handleShowRejectionMessage = (message) => {
    setRejectionMessage(message || "No rejection message provided.");
    setShowRejectionModal(true);
  };


  useEffect(() => {
    const fetchData = async () => {
      if (!auth.currentUser) return;
      // 🔹 Fetch logged-in user's document
      const userDoc = await getDoc(doc(db, "users", auth.currentUser.uid));
      if (userDoc.exists()) {
        const userData = userDoc.data();
        setSoName(userData.name || "");
        setPartyCode(userData.partyCode || "");
        // setPartyName(userData.partyName || "");
      }

      // 🔹 Fetch products
      const productsRef = collection(db, "products");
      const productsSnapshot = await getDocs(productsRef);
      setProducts(productsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      if (!auth.currentUser) return;
      setLoadingOrders(true);
      try {
        const ordersQuery = query(collection(db, "orders"), where("soId", "==", auth.currentUser.uid));
        const querySnapshot = await getDocs(ordersQuery);
        const ordersData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const sorted = ordersData.sort((a, b) => {
          const dateA = a.createdAt?.toDate?.() || new Date(0);
          const dateB = b.createdAt?.toDate?.() || new Date(0);
          return dateB - dateA;
        });
        setOrders(sorted);
      } catch (err) {
        console.error("Error fetching orders:", err);
        setOrders([]);
      } finally {
        setLoadingOrders(false);
      }
    };

    if (activeTab === "orders") {
      fetchOrders();
    }
  }, [activeTab]);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/");
    window.location.reload();
  };

  const handleAddProduct = () => {
    setSelectedProducts([...selectedProducts, { productId: "", quantity: "" }]);
  };

  const handleProductChange = (index, field, value) => {
    const updated = [...selectedProducts];
    updated[index][field] = value;
    setSelectedProducts(updated);
  };

  const resetOrderForm = () => {
    setSelectedProducts([]);
    setPartyMobile("");
    setPod("");
    setContactInfo(""); // ✅ will clear to empty initialized state
    // setLedgerProductSearchTerm("");
  };




  const handleSubmitOrder = async () => {
    if (submitting) return;


    if (!partyMobile.trim()) {
      toast.error("Please Enter The Party Phone Number.");
      return;
    }

    if (!pod.trim()) {
      toast.error("Please Enter The POD.");
      return;
    }

    if (!contactInfo.trim()) {
      toast.error("Please Enter Contact Info.");
      return;
    }

    if (selectedProducts.length === 0) {
      toast.error("Please Add At Least One Product.");
      return;
    }

    const incompleteProduct = selectedProducts.find(
      (p) => !p.productId || !p.quantity || parseInt(p.quantity) <= 0
    );

    if (incompleteProduct) {
      toast.error("Please Enter Valid Quantity");
      return;
    }

    const refCode = `ORD-${new Date().getFullYear()}-${Date.now().toString().slice(-6)}`;

    const enrichedProducts = selectedProducts.map(p => {
      const product = products.find(prod => prod.id === p.productId);
      return product
        ? {
          productId: p.productId,
          name: product.name || "",
          category: product.category || "N/A",
          variety: product.variety || "N/A",
          packSize: product.packSize || "N/A",
          packType: product.packType || "N/A",
          quantity: p.quantity,
        }
        : {
          productId: p.productId,
          name: "Unknown",
          category: "N/A",
          variety: "N/A",
          packSize: "N/A",
          packType: "N/A",
          quantity: p.quantity,
        };
    });


    const order = {
      refCode,
      soId: auth.currentUser.uid,
      soName,
      createdBy: auth.currentUser.uid,
      createdByName: soName,
      partyCode,
      partyName: soName,
      partyMobile,
      pod,
      contactInfo,
      products: enrichedProducts,
      status: "Placed",
      createdAt: serverTimestamp(),
    };

    try {
      setSubmitting(true);
      await addDoc(collection(db, "orders"), order);
      toast.success("Order placed successfully!");
      resetOrderForm();
    } catch (err) {
      console.error("Failed to place order:", err);
      toast.error("Failed to place order. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const renderOrdersList = () => {
    if (loadingOrders) return <p>Loading orders...</p>;

    const filteredOrders = orders.filter(order => {
      const orderDate = order.createdAt?.toDate?.();
      const matchesStartDate = filterStartDate ? orderDate >= new Date(filterStartDate) : true;
      const matchesEndDate = filterEndDate ? orderDate <= new Date(filterEndDate + "T23:59:59") : true;
      const matchesProduct = filterProduct
        ? (order.products || []).some((p) => (p.name || "").trim() === filterProduct)
        : true;
      return matchesStartDate && matchesEndDate && matchesProduct;
    });

    const totalPages = Math.ceil(filteredOrders.length / pageSize);
    const paginatedOrders = filteredOrders.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    if (!filteredOrders.length) return <p>No matching orders found.</p>;

    return (
      <>
        <div className={styles.responsiveTable}>
          <table className={styles.ordersTable}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Party</th>
                <th>Party Number</th>
                <th>POD</th>
                <th>Contact Info</th>
                <th>Status</th>
                <th>Product</th>
                <th>Total Qty</th>
              </tr>
            </thead>
            <tbody>
              {paginatedOrders.map(order => {
                const filteredProducts = order.products.filter(p => p.addedBy !== "LM");
                const rowStyle =
                  order.status === "Approved"
                    ? { backgroundColor: "#d4edda" }
                    : order.status === "Rejected" || order.status === "Rejected By Logistic"
                      ? { backgroundColor: "#f8d7da" }
                      : {};

                return filteredProducts.length === 0 ? (
                  <tr key={order.id} style={rowStyle}>
                    <td>{order.createdAt?.toDate ? order.createdAt.toDate().toLocaleString() : "N/A"}</td>
                    <td>{order.partyName}</td>
                    <td>{order.partyMobile || "N/A"}</td>
                    <td>{order.pod || "N/A"}</td>
                    <td>{order.contactInfo || "N/A"}</td>
                    <td>{order.status}</td>
                    <td colSpan="2">No Products</td>
                  </tr>
                ) : (
                    filteredProducts.map((product, idx) => (
                    <tr key={`${order.id}-${idx}`} style={rowStyle}>
                      {idx === 0 && (
                        <>
                          <td rowSpan={filteredProducts.length}>
                            {order.createdAt?.toDate ? order.createdAt.toDate().toLocaleString() : "N/A"}
                          </td>
                          <td rowSpan={filteredProducts.length}>{order.partyName}</td>
                          <td rowSpan={filteredProducts.length}>{order.partyMobile || "N/A"}</td>
                          <td rowSpan={filteredProducts.length}>{order.pod || "N/A"}</td>
                          <td rowSpan={filteredProducts.length}>{order.contactInfo || "N/A"}</td>
                          <td rowSpan={filteredProducts.length}>
                            <span
                              className={`${styles.statusBadge} ${order.status.toLowerCase().includes("approved")
                                ? styles.approved
                                : order.status.toLowerCase().includes("rejected")
                                  ? styles.rejected
                                  : styles.pending
                                }`}
                            >
                              {order.status}
                            </span>
                            {["Rejected", "Rejected By Logistic"].includes(order.status) &&
                              order.rejectionMessage && (
                                <span
                                  onClick={() => handleShowRejectionMessage(order.rejectionMessage)}
                                  title="View Rejection Reason"
                                  style={{
                                    marginLeft: "8px",
                                    cursor: "pointer",
                                    color: "#dc3545",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ❗
                                </span>
                              )}
                          </td>
                        </>
                      )}

                      <td>
                        {product.name} - {product.variety} - {product.packSize} {product.packType} × {product.quantity}
                      </td>

                      {/* ✅ Total Quantity should appear only once */}
                      {idx === 0 && (
                        <td rowSpan={filteredProducts.length}>
                          <strong>
                            {order.products?.reduce(
                              (sum, p) => sum + (parseFloat(p.quantity) || 0),
                              0
                            )}
                          </strong>
                        </td>
                      )}

                      {/* {idx === 0 && (
                        <td rowSpan={filteredProducts.length}>
                          {order.ledger && order.ledger.length > 0 ? (
                            <div className={styles.ledgerSummary}>
                              <div className={styles.netBalance}>
                                <b>Balance: </b>
                                {(() => {
                                  const balance = (order.ledger || []).reduce(
                                    (acc, entry) =>
                                      acc + (parseFloat(entry.credit) || 0) - (parseFloat(entry.debit) || 0),
                                    0
                                  );
                                  return balance >= 0 ? `${balance} Cr` : `${Math.abs(balance)} Dr`;
                                })()}
                              </div>

                              <details>
                                <summary className={styles.collapsibleButton}>View Ledger Entries</summary>
                                {Object.entries(
                                  order.ledger.reduce((acc, entry) => {
                                    if (!acc[entry.productName]) acc[entry.productName] = [];
                                    acc[entry.productName].push(entry);
                                    return acc;
                                  }, {})
                                ).map(([cropName, entries]) => (
                                  <div key={cropName} className={styles.cropGroup}>
                                    <div className={styles.cropName}>{cropName}</div>
                                    <table className={styles.cropLedgerTable}>
                                      <thead>
                                        <tr>
                                          <th>Season</th>
                                          <th>Debit</th>
                                          <th>Credit</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {entries.map((entry, i) => (
                                          <tr key={i}>
                                            <td>{entry.season || "N/A"}</td>
                                            <td>{entry.debit ? `Dr: ${parseFloat(entry.debit).toFixed(2)}` : ""}</td>
                                            <td>{entry.credit ? `Cr: ${parseFloat(entry.credit).toFixed(2)}` : ""}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                ))}
                              </details>
                            </div>
                          ) : (
                            "N/A"
                          )}
                        </td>
                      )} */}
                    </tr>
                  ))
                );
              })}
            </tbody>
          </table>
        </div>

        <div className={styles.pagination}>
          <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)}>
            Previous
          </button>
          <span style={{ margin: "0 10px" }}>
            Page {currentPage} of {totalPages}
          </span>
          <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(prev => prev + 1)}>
            Next
          </button>
        </div>
      </>
    );
  };

  // helper functions for category constraints
  const isVegetableOrPearlMillat = (product) => {
    if (!product) return false;
    const name = product.name?.toLowerCase() || "";
    const category = product.category?.toLowerCase() || "";
    return category === "vegetables" || category === "pearl millet" || name.includes("pearl millet") || category === "hyrbid mustard" || category === "mustard" || name.includes("mustard");
  };

  const hasVegetableOrPearlMillatSelected = selectedProducts.some((p) => {
    const prod = products.find((prod) => prod.id === p.productId);
    return isVegetableOrPearlMillat(prod);
  });

  const hasOtherProductSelected = selectedProducts.some((p) => {
    const prod = products.find((prod) => prod.id === p.productId);
    return prod && !isVegetableOrPearlMillat(prod);
  });


  return (
    <div className={styles.dashboardContainer}>
      <ToastContainer position="top-center" />

      {/* 🔹 Mobile Header */}
      <div className={styles.mobileHeader}>
        <div className={styles.logoContainer}>
          <img src={logo || "/logo.jpg"} alt="Logo" className={styles.logo} />
          <h2 className={styles.dashboardTitle}>Dashboard</h2>
        </div>
        <p className={styles.userName}>{soName}</p>
        <button
          className={styles.hamburger}
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <FiMenu size={24} />
        </button>
      </div>

      {/* 🔹 Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className={styles.overlay}
          onClick={() => setSidebarOpen(false)} // close on click outside
        ></div>
      )}

      <aside className={`${styles.sidebar} ${sidebarOpen ? styles.showSidebar : ""}`}>
        <div className={styles.sidebarHeader}>
          <div className={styles.logoContainer}>
            <img src={logo || "/logo.jpg"} alt="Logo" className={styles.logo} />
            <p className={styles.userName}>{soName}</p>
          </div>
        </div>

        <div className={styles.sidebarLinks}>
          <button
            onClick={() => setActiveTab("placeOrder")}
            className={activeTab === "placeOrder" ? styles.activeTab : ""}
          >
            Place Order
          </button>
          <button
            onClick={() => setActiveTab("orders")}
            className={activeTab === "orders" ? styles.activeTab : ""}
          >
            View Orders
          </button>
        </div>

        {/* 🔹 Footer Logout */}
        <div className={styles.sidebarFooter}>
          <button onClick={handleLogout} className={styles.logoutButton}>
            Logout
          </button>
        </div>
      </aside>

      {/* 🔹 Main Content */}
      <main className={styles.mainContent}>
        {activeTab === "placeOrder" && (
          <div className={styles.card}>
            <h3 className={styles.sectionTitle}>Place New Order</h3>

            {/* Party Details */}
            <label>Party Phone Number</label>
            <input
              type="text"
              value={partyMobile}
              onChange={(e) => setPartyMobile(e.target.value)}
              className={styles.inputField}
              placeholder="Enter Party Phone Number"
            />

            <label>POD</label>
            <textarea
              value={pod}
              onChange={(e) => setPod(e.target.value)}
              placeholder="Enter Your POD"
              className={styles.textarea}
            />

            <label>Contact Info</label>
            <textarea
              value={contactInfo}
              onChange={(e) => setContactInfo(e.target.value)}
              placeholder="Enter Phone Number and Delivery Address"
              className={styles.textarea}
            />

            {/* Products */}
            {selectedProducts.map((product, index) => (
              <div key={index} className={styles.productRow}>
                <select
                  value={product.productId}
                  onChange={(e) => {
                    const selectedProd = products.find(
                      (p) => p.id === e.target.value
                    );
                    if (!selectedProd) return;

                    const isVegetableOrPearl = isVegetableOrPearlMillat(selectedProd);

                    if (isVegetableOrPearl && hasOtherProductSelected) {
                      toast.warning(
                        "You cannot select Vegetables or Pearl Millet with other products."
                      );
                      return;
                    }

                    if (!isVegetableOrPearl && hasVegetableOrPearlMillatSelected) {
                      toast.warning(
                        "You cannot select other products with Vegetables or Pearl Millet."
                      );
                      return;
                    }

                    handleProductChange(index, "productId", e.target.value);
                  }}
                  className={styles.productSelect}
                >
                  <option value="">Select Product</option>
                  {Array.from(new Set(products.map((p) => p.category))).map(
                    (category) => (
                      <optgroup label={category} key={category}>
                        {products
                          .filter((p) => p.category === category)
                          .map((p) => {
                            const disable =
                              (hasVegetableOrPearlMillatSelected &&
                                !isVegetableOrPearlMillat(p)) ||
                              (hasOtherProductSelected &&
                                isVegetableOrPearlMillat(p));

                            return (
                              <option
                                key={p.id}
                                value={p.id}
                                disabled={disable}
                              >
                                {p.name} - {p.variety} - {p.packSize} -{" "}
                                {p.packType}
                              </option>
                            );
                          })}
                      </optgroup>
                    )
                  )}
                </select>

                <input
                  type="number"
                  placeholder="Qty"
                  min="1"
                  value={product.quantity}
                  onChange={(e) =>
                    handleProductChange(index, "quantity", e.target.value)
                  }
                  className={styles.qtyInput}
                />
                <button
                  onClick={() => {
                    const updated = selectedProducts.filter((_, i) => i !== index);
                    setSelectedProducts(updated);
                  }}
                  className={styles.removeBtn}
                >
                  Remove
                </button>
              </div>
            ))}
            <button onClick={handleAddProduct} className={styles.addBtn}>
              + Add Product
            </button>

            {/* ✅ Total Quantity Summary */}
            {selectedProducts.length > 0 && (
              <div style={{ marginTop: "10px", fontWeight: "bold" }}>
                Total Quantity:{" "}
                {selectedProducts.reduce(
                  (sum, p) => sum + (parseFloat(p.quantity) || 0),
                  0
                )}
              </div>
            )}


            {/* Actions */}
            <div className={styles.actionButtons}>
              <button
                onClick={handleSubmitOrder}
                className={styles.submitBtn}
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Submit Order"}
              </button>
              <button onClick={resetOrderForm} className={styles.cancelBtn}>
                Reset
              </button>
            </div>
          </div>
        )}

        {/* Orders Section */}
        {activeTab === "orders" && (
          <div className={styles.card}>
            <h2 className={styles.sectionTitle}>My Orders</h2>
            <div className={styles.orderCounts}>
              <span className={styles.totalBox}>
                Total Orders: {orders.length}
              </span>
              <span className={styles.pendingBox}>
                Pending: {orders.filter((o) => o.status === "Pending").length}
              </span>
              <span className={styles.approvedBox}>
                Approved: {orders.filter((o) => o.status === "Approved").length}
              </span>
              <span className={styles.rejectedBox}>
                Rejected:{" "}
                {
                  orders.filter(
                    (o) =>
                      o.status === "Rejected" ||
                      o.status === "Rejected By Logistic"
                  ).length
                }
              </span>
            </div>

            {/* Filters */}
            <div className={styles.filterContainer}>
              <label>Start Date: </label>
              <input
                type="date"
                value={filterStartDate}
                onChange={(e) => setFilterStartDate(e.target.value)}
              />
              <label>End Date: </label>
              <input
                type="date"
                value={filterEndDate}
                onChange={(e) => setFilterEndDate(e.target.value)}
              />
              <label>Product: </label>
              <select
                value={filterProduct}
                onChange={(e) => setFilterProduct(e.target.value)}
              >
                <option value="">All</option>
                {[...new Set(
                  orders.flatMap((o) =>
                    (o.products || [])
                      .map((p) => (p.name || "").trim())
                      .filter((name) => name && name.toLowerCase() !== "n/a")
                  )
                )].sort().map((product, idx) => (
                  <option key={idx} value={product}>{product}</option>
                ))}
              </select>
            </div>

            {/* Rejection Modal */}
            {showRejectionModal && (
              <div className={styles.modalOverlay}>
                <div className={styles.modalContent}>
                  <h3>Rejection Message</h3>
                  <p>{rejectionMessage}</p>
                  <button
                    onClick={() => setShowRejectionModal(false)}
                    className={styles.modalCloseBtn}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

            {renderOrdersList()}
          </div>
        )}
      </main>
    </div>

  );
};

export default DealerDashboard;
